import React from "react";

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
  }, []);

const handleLogout = () => {
  localStorage.removeItem("cart");
  localStorage.removeItem("selectedAddons");
  localStorage.removeItem("addons");
  localStorage.removeItem("finalPrice");
  localStorage.removeItem("user");

  window.location.href = "/";
};

  return (
    <header className="th-header header-layout1">
      <div className="sticky-wrapper">
        <div className="menu-area">
          <div className="container th-container">
            <div className="row align-items-center justify-content-between">

              {/* LOGO */}
              <div className="col-auto">
                <div className="header-logo">
                  <Link to="/">
                    <img
                      src="/assets/img/indiaboatslogo.png"
                      alt="India Boats"
                    />
                  </Link>
                </div>
              </div>

              {/* MENU */}
              <div className="col-auto">
                <nav className="main-menu d-none d-xl-inline-block">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>

                    <li>
                      <Link to="/about">About Us</Link>
                    </li>

                    <li>
                      <Link to="/deals">Deals</Link>
                    </li>

                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
<li>
  {!isLoggedIn &&  <Link to="/login">Login</Link>}
                     
                    </li>
                    
<li>
 {isLoggedIn && <Link to="/cart">Cart</Link>}
</li>
<li>
 {isLoggedIn && <Link to="/profile">Profile</Link>}
</li>
{/* <li>
 {isLoggedIn && <Link to="/confirmbooking">Booking</Link>}
</li> */}
<li>
 {isLoggedIn && <Link to="/OrderDetails">Order Details</Link>}
</li>
<li>
 {isLoggedIn && <button onClick={handleLogout} style={{ border: "none", background: "none", cursor: "pointer" }}>
      Logout
    </button>}
</li>


                  </ul>
                </nav>

                {/* MOBILE MENU BUTTON */}
                <button
                  type="button"
                  className="th-menu-toggle d-block d-xl-none"
                >
                  <i className="far fa-bars" />
                </button>
              </div>

              {/* BUTTON */}
              <div className="col-auto d-none d-xl-block">
                <div className="header-button">
                  <Link to="/deals" className="th-btn style3 th-icon">
                    Deals
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
